import { isString, isNotEmpty } from 'core/utils/string'

import { type BidLoadStop } from '../domain/Bid'

export function formatZip({ zipcode }: BidLoadStop): string | undefined {
  if (isString(zipcode) && isNotEmpty(zipcode)) {
    return `ZIP ${zipcode}`
  }
}
